'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getRegexMatchStr = require('./getRegexMatchStr');

var _getRegexMatchStr2 = _interopRequireDefault(_getRegexMatchStr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAllImports = function getAllImports(code) {
  var matcher = new RegExp((0, _getRegexMatchStr2.default)(), 'g');
  var matches = [];
  var m = matcher.exec(code);

  while (m) {
    // $1 and $3 capture groups are used for 'require' statements, while $4 and $6
    // are used for 'import' statements
    if (m[1] && m[2] && m[3]) {
      matches.push(m[2]);
    } else if (m[4] && m[5] && m[6]) {
      matches.push(m[5]);
    }
    code = code.slice(m.index + m[0].length);
    matcher = new RegExp((0, _getRegexMatchStr2.default)(), 'g');
    m = matcher.exec(code);
  }
  return matches;
};

exports.default = getAllImports;


//////////////////
// WEBPACK FOOTER
// ./~/codesandboxer/dist/utils/getAllImports.js
// module id = 435
// module chunks = 168707334958949